import { ClickToCopyCollection } from './js/clickToCopy'

import './modules/admin-lte/adminlte.css'
import 'selectric/public/selectric.css'

// Load plugins
import 'jquery'
import IMask from 'imask'
import '@fortawesome/fontawesome-free/js/all.min.js'
import './modules/admin-lte/adminlte'
// import 'bootstrap/js/dist/tab' конфликт на бэка
import 'admin-lte/build/js/CardWidget'
import svg4everybody from 'svg4everybody'

import objectFitImages from 'object-fit-images'

import imagesLoaded from 'imagesloaded'

import stopHandler from './js/stopHandler'
import closeCard from './js/closeCard'

// load modules
import Utils from './js/utils/utils'
import AjaxLink from './js/utils/ajaxLink'
import SvgUse from './js/svgUse'
import Tabs from './js/tabs'
import SyncManager from './js/syncManager'
import RightSidebarModel from './js/rightSidebar'
import CustomTabs from './js/customTabs'
import Sliders from './js/sliders'
import Modals from './js/modals'
import Forms from './js/forms/forms'
import CustomSelect, { CustomSelectWithSelectric, DynamicCustomSelect } from './js/customSelect'
import Collapse, { TableCollapse } from './js/collapse'
import { NextStepCollection } from './js/nextStep'
import FilterLinks from './js/filterLinks'
import { ModelViewerCollection } from './js/ModelViewer'

/* import PhonePicker from './js/phonePicker' */
import { PhonePickerCollection } from './js/phonePickerNew'
import { TableCollection } from './js/table'
import { TableFiltersCollection } from './js/tableFilters'
import DynamicSelect from './js/forms/dynamicSelect'
import CatalogFilter from './js/catalogFilter'
import { goWithoutAuth } from './js/goWithoutAuth'
import { AddToCartCollection } from './js/addToCart'
import { AddToFavoritesCollection } from './js/addToFavorites'
import { RemoveFromFavorites } from './js/removeFromFavorites'
import { DellFromCartCollection } from './js/dellFromCart'
import { ToggleViewCollection } from './js/toggleView'
import ChooseMultipleCollection from './js/chooseMultiple'
import PageReload from './js/pageReload'
import { AssociatedControlCollection } from './js/associatedControl'
import { ProductStatusCollection } from './js/productStatus'
import { CalculateTableCollection } from './js/calculateTable'
import { CalculatorCollection } from './js/calculator'
import { CalculatorMaCollection } from './js/calculator-ma'
import { RangeSliderCollection } from './js/rangeSlider'
import { PaginationCollection } from './js/pagination'
import { CurrencyChartCollection } from './components/currency-chart'
import { CurrencyChartMaCollection } from './components/currency-chart-ma'
import { DetailProductModalCollection } from './js/detailProductModal'

// Load components

// import ExampleComponent from "./components/_example";
import './components/breadcrumbs'
import './components/sidebar'
import './components/default-table'
import './components/custom-table'
import './components/table-filter'
import './components/detail-card'
import './components/features-list'
import './components/navbar'
import './components/calculate-table'
import './components/calculator'
import './components/calculator-ma'
import './components/catalog-list'
import './components/favorites-table'
import './components/multi-step'
import './components/box-checkbox'
import './components/rim-block'
import './components/right-sidebar'
import './components/next-step'
import './components/detail-product-modal'
import './components/pageHeader'
import './components/logo'
import './components/mainBanner'

// Load styles
import './styles/app.js'


function requireAll (r) {
  r.keys().forEach(r)
}

requireAll(require.context('./icons', true, /\.svg$/))

window.svg4everybody = svg4everybody

window.objectFitImages = objectFitImages

window.imagesLoaded = imagesLoaded

// Run components

window.App = {
  lang: 'ru'
}

if (window.SITE_LANG) {
  App.lang = window.SITE_LANG
}

document.addEventListener('DOMContentLoaded', function () {
  objectFitImages()
  App.debug = window.location.port.length || (window.location.search.indexOf('debug') > -1)

  App.Utils = new Utils()
  App.AjaxLink = new AjaxLink()
  App.Forms = new Forms()
  App.SvgUse = new SvgUse()
  App.Sliders = new Sliders()
  App.Tabs = new Tabs()
  App.Modals = new Modals()
  App.CustomSelect = new CustomSelect()
  App.NextStepCollections = new NextStepCollection()
  App.DynamicCustomSelect = new DynamicCustomSelect()
  App.CustomSelectWithSelectric = new CustomSelectWithSelectric()
  App.Range = new Range()
  App.FilterLinks = new FilterLinks()
  App.Collapse = new Collapse()
  App.TableCollapse = new TableCollapse()
  /*  App.PhonePicker = new PhonePicker() */
  App.PhonePickerCollection = new PhonePickerCollection()
  App.CustomTabs = new CustomTabs()
  App.TableFiltersCollection = new TableFiltersCollection()
  App.DynamicSelect = new DynamicSelect()
  App.CatalogFilter = new CatalogFilter()
  App.TableCollection = new TableCollection()
  App.AddToCartCollection = new AddToCartCollection()
  App.AddToFavoritesCollection = new AddToFavoritesCollection()
  App.RemoveFromFavorites = new RemoveFromFavorites()
  App.DellFromCartCollection = new DellFromCartCollection()
  App.ToggleViewCollection = new ToggleViewCollection()
  App.ChooseMultipleCollection = new ChooseMultipleCollection()
  App.PageReload = new PageReload()
  App.AssociatedControlCollection = new AssociatedControlCollection()
  App.ProductStatusCollection = new ProductStatusCollection()
  App.ClickToCopyCollection = new ClickToCopyCollection()
  App.CalculateTableCollection = new CalculateTableCollection()
  App.CalculatorCollection = new CalculatorCollection()
  App.CalculatorMaCollection = new CalculatorMaCollection()
  App.RangeSliderCollection = new RangeSliderCollection()
  App.CurrencyChartCollection = new CurrencyChartCollection()
  App.CurrencyChartMaCollection = new CurrencyChartMaCollection()
  App.PaginationCollection = new PaginationCollection()
  App.DetailProductModalCollection = new DetailProductModalCollection()
  App.RightSidebar = new RightSidebarModel()
  App.SyncManager = new SyncManager()
  App.ModelViewerCollection = new ModelViewerCollection()


  $('[data-js-textMask]').each(function () {
    IMask($(this)[0], {
      mask: /^\D+$/,
      max: 20
    })
  })

  $('[data-js-textMask-large]').each(function () {
    IMask($(this)[0], {
      mask: /^\D+$/
    })
  })

  $('[data-js-number-mask]').each(function (...item) {
    IMask($(this)[0], {
      mask: /^\d+$/
    })
  })

  $('[data-js-number-float-mask]').each(function () {
    IMask($(this)[0], {
      mask: /^\d*[\,|\.']?\d*$/
    })
  })

  $('[data-js-filter-size-mask]').each(function () {
    IMask($(this)[0], {
      mask: Number,
      min: 0,
      max: 10000,
      thousandsSeparator: ' '
    })
  })

  $('[data-js-filter-size-input-mask]').each(function () {
    IMask($(this)[0], {
      mask: Number,
      scale: 1,
      thousandsSeparator: ' ',
      padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
      normalizeZeros: true, // appends or removes zeros at ends
      radix: ',', // fractional delimiter
      mapToRadix: ['.', ','],
      min: 0.1,
      max: 10000
    })
  })

  $('[data-js-filter-currency-mask]').each(function () {
    IMask($(this)[0], {
      mask: Number,
      scale: 1,
      thousandsSeparator: ' ',
      padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
      normalizeZeros: true, // appends or removes zeros at ends
      radix: ',', // fractional delimiter
      mapToRadix: ['.', ','],
    })
  })

  // prevent copying

  $('.no-select').on('selectstart', false)

  $('.no-select img').on('mousedown', false)

  stopHandler('.custom-table__header .default-checkbox')
  stopHandler('.custom-table__body .default-checkbox')
  goWithoutAuth()
  closeCard()
})
